import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Form } from 'react-bootstrap';

import CrossChannelActions from '../../actions/CrossChannelActions';
import RunNameInput from './components/RunNameInput.react';
import TotalBudgetInput from './components/TotalBudgetInput.react';
import SelectInput from '../../components/form_components/SelectInput.react';
import ModeOptions from './components/ModeOptions.react';
import ButtonPanel from './components/ButtonPanel.react';
import CrossChannelDiscountInput from './components/CrossChannelDiscountInput.react';
import { QueryPropTypes } from '../../util/helpers/SharedPropTypes';

function modeOptionForSelect(mode) {
  return {
    value: mode.key,
    displayValue: mode.displayLabel,
  };
}

function universeOptionForSelect(query) {
  return {
    value: query.id,
    displayValue: query.name,
  };
}

export default class CrossChannelParametersForm extends React.Component {
  constructor(props) {
    super(props);
    this.resetSettings = this.resetSettings.bind(this);
    this.complete = this.complete.bind(this);
    this.saveScenario = this.saveScenario.bind(this);

    this.updateParameter = CrossChannelActions.updateValue.bind(this, props.organizationId);
    this.updateDiscount = this.updateParameter.bind(this, 'jobDiscount');
    this.updateBudget = this.updateParameter.bind(this, 'totalBudget');
    this.updateRunName = this.updateParameter.bind(this, 'runName');
    this.updateTargetUniverse = this.updateParameter.bind(this, 'targetUniverse');
    this.updateUpliftScore = this.updateParameter.bind(this, 'upliftScore');
    this.updateTargetListSubsetMode = this.updateParameter.bind(this, 'targetListSubsetMode');
    this.updateTargetListSubsetUniverse = this.updateParameter.bind(this, 'targetListSubsetUniverse');
  }

  showAdvanced() {
    CrossChannelActions.toggleAdvanced();
  }

  resetSettings() {
    CrossChannelActions.reset(this.props.organizationId);
  }

  complete() {
    // Save a scenario, then run it once you get the saved job ID back
    CrossChannelActions.saveScenario(this.props.organizationId,
      this.props.job.configJson).then((saveResponse) => {
        const savedScenarioId = saveResponse.body.data.id;
        CrossChannelActions.runSavedScenario(savedScenarioId).then(() => {
          const { router } = this.context;
          router.push('/crosschannel/new/complete/');
        });
      }).catch((e) => {
        console.error(e);
      });
  }

  saveScenario() {
    CrossChannelActions.saveScenario(this.props.organizationId,
      this.props.job.configJson).then(() => {
        const { router } = this.context;
        router.push('/crosschannel/');
      }).catch((e) => {
        console.error(e);
      });
  }

  render() {
    return (
      <div>
        <Form>
          <RunNameInput
            value={this.props.job.runName}
            onChange={this.updateRunName}
          />
          <SelectInput
            attribute='targetUniverse'
            displayName='Target Universe'
            helpText='BlueLabs may have cut this universe, or you may have provided a list of target IDs. Please describe how to access that universe.'
            valueOptions={this.props.availableTargetUniverses.map(universeOptionForSelect)}
            value={this.props.job.targetUniverse}
            updateFunc={this.updateTargetUniverse}
          />
          <SelectInput
            attribute='upliftScore'
            displayName='Uplift Score'
            optional
            helpText='If a persuasion or message uplift score is available and should be used in this scenario, please describe how to access that score.'
            valueOptions={this.props.availableUpliftScores.map(universeOptionForSelect)}
            value={this.props.job.upliftScore}
            updateFunc={this.updateUpliftScore}
          />
          <TotalBudgetInput
            totalBudget={this.props.job.totalBudget}
            updateBudget={this.updateBudget}
          />

          {
            this.props.advancedSettings &&
            <div id='crosschannel-advanced-settings'>
              <CrossChannelDiscountInput
                value={this.props.job.jobDiscount}
                onChange={this.updateDiscount}
              />
              <SelectInput
                attribute='targetListSubsetUniverse'
                displayName='Mode-Specific Subset Universe'
                optional
                helpText='This option is not normally used. Allows for targeting a pre-loaded subset of the overall target universe on a single mode, often used in conjunction with an exact spending constraint on that mode.'
                valueOptions={this.props.availableTargetUniverses.map(universeOptionForSelect)}
                value={this.props.job.targetListSubsetUniverse}
                updateFunc={this.updateTargetListSubsetUniverse}
              />
              <SelectInput
                attribute='targetListSubsetMode'
                displayName='Mode-Specific Subset to Target'
                optional
                valueOptions={this.props.job.modeOptions.map(mode => modeOptionForSelect(mode))}
                value={this.props.job.targetListSubsetMode}
                updateFunc={this.updateTargetListSubsetMode}
              />
            </div>
          }

          <ModeOptions advancedSettings={this.props.advancedSettings} {...this.props} />
        </Form>
        <ButtonPanel
          resetSettings={this.resetSettings}
          showAdvanced={this.showAdvanced}
          saveScenario={this.saveScenario}
          valid={this.props.job.valid}
          complete={this.complete}
        />
      </div>
    );
  }
}

CrossChannelParametersForm.propTypes = {
  job: PropTypes.object,
  organizationId: PropTypes.number,
  availableTargetUniverses: ImmutablePropTypes.iterableOf(QueryPropTypes),
  availableUpliftScores: ImmutablePropTypes.iterableOf(QueryPropTypes),
  advancedSettings: PropTypes.bool,
};

CrossChannelParametersForm.contextTypes = {
  router: PropTypes.object,
};
